// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__Ep-7B","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2kzKy"};